import React from 'react'
import {Menu} from 'antd'
import {SiderMenuProps} from './props'
import styles from './styles.scss'

export const SiderMenu: React.FC<SiderMenuProps> = ({
    collapsed,
    menuItems,
    openKeys,
    selectedKeys,
    onOpenChange,
    className
}) => {
    // Map MenuDataItem to Ant Design Menu items format
    const convertMenuItems = (items: any[]): any[] => {
        return items.map(item => ({
            key: item.key || item.routeKey || item.name, // Ensure each item has a key
            label: item.label || item.name,
            icon: item.icon,
            children: item.children ? convertMenuItems(item.children) : undefined,
            disabled: item.disabled
        }))
    }

    return (
        <Menu
            mode='inline'
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            className={className}
            items={convertMenuItems(menuItems)}
            inlineCollapsed={collapsed}
        />
    )
}